import React, { useEffect, useState, Suspense } from "react";
import { supabase } from "./supabase.js";

/* Panel girişten sonra yükleniyor. Tek parça paket 1,3 MB'tı ve giriş ekranında
   bile tamamı iniyordu — fabrika terminalinde ve telefonda ilk açılış yavaştı. */
const EricanPanel = React.lazy(() => import("./erican_panel.jsx"));

/* Oturum kabuğu. Panelin geri kalanı erican_panel.jsx içinde. */

// Panel içindeki inputCls ile aynı görünüm; App.jsx bağımsız kalsın diye kopya
const inputCls = "w-full rounded-lg border border-zinc-300 bg-white px-3 py-2 text-sm " +
  "placeholder:text-zinc-400 hover:border-zinc-400 " +
  "focus:border-zinc-900 focus:ring-2 focus:ring-zinc-900/10 focus:outline-none transition-colors";

/* Ortaklardan biri Türk biri Çinli ve tedarik Handan'dan geliyor. İki şehrin
   saati yan yana durunca ekran hem yerinde hem işe yarıyor: Çin'i aramadan
   önce oradaki saati görüyorsun (5 saat ileri). Intl kullanıyor — yaz saati
   dahil doğru, ek kütüphane yok. Giriş ekranı ayrı paket olduğu için burada
   ağır bir şey kullanmamak önemli. */
const SEHIRLER = [
  { ad: "Salihli", alt: "Manisa · TR", tz: "Europe/Istanbul" },
  { ad: "Baoding", alt: "保定 · Hebei, CN", tz: "Asia/Shanghai" },
];

function Saatler() {
  const [simdi, setSimdi] = useState(() => new Date());
  useEffect(() => {
    // Dakika başına hizala, sonra dakikada bir — saniyede bir render gereksiz
    const t = setTimeout(function tik() {
      setSimdi(new Date());
      t2 = setTimeout(tik, 60000);
    }, (60 - new Date().getSeconds()) * 1000);
    let t2;
    return () => { clearTimeout(t); clearTimeout(t2); };
  }, []);

  return (
    <div className="grid grid-cols-2 divide-x divide-white/10">
      {SEHIRLER.map((s) => (
        <div key={s.ad} className="px-4 py-3">
          <div className="text-[10px] uppercase tracking-[0.14em] text-white/40">{s.ad}</div>
          <div className="font-mono text-2xl text-white leading-tight tabular-nums">
            {simdi.toLocaleTimeString("tr-TR", { timeZone: s.tz, hour: "2-digit", minute: "2-digit" })}
          </div>
          <div className="text-[10px] text-white/35 mt-0.5">
            {s.alt} · {simdi.toLocaleDateString("tr-TR", { timeZone: s.tz, day: "2-digit", month: "short" })}
          </div>
        </div>
      ))}
    </div>
  );
}

/* Giriş ekranının boş beyaz zemini. Ürünün kendisi desen oluyor: teneke kutu
   siluetleri çok soluk, kaydırılmış sıralar hâlinde — üretim bandındaki
   diziliş gibi. Üstünde markanın sarısı ve bayrakların kırmızısı yumuşak
   ışık lekeleri olarak duruyor.
   Tamamı tek bir inline SVG: ek dosya yok, ağ isteği yok, ölçekle bozulmuyor.
   aria-hidden — ekran okuyucu için anlamı yok, giriş formunu boğmasın. */
function Zemin() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 overflow-hidden">
      <div className="absolute inset-0" style={{
        background:
          "radial-gradient(70% 55% at 15% 8%, rgba(245,184,0,.16) 0%, transparent 60%)," +
          "radial-gradient(65% 55% at 88% 92%, rgba(232,17,45,.11) 0%, transparent 62%)," +
          "linear-gradient(160deg, #FBFBFA 0%, #F4F4F2 100%)",
      }} />
      <svg className="absolute inset-0 w-full h-full">
        <defs>
          {/* Çizgi ayarları tanımın kendisinde olmalı: <use> kopyaları, onları
              saran <g>'den değil kaynak düğümden miras alıyor. Dışarıda
              bıraktığımda kutular dolu siyah çıktı. */}
          <g id="kutu" fill="none" stroke="#18181b" strokeWidth="1.15" strokeOpacity=".07" strokeLinejoin="round">
            <ellipse cx="22" cy="10" rx="15" ry="5.5" />
            <path d="M7 10v34c0 3 6.7 5.5 15 5.5s15-2.5 15-5.5V10" />
            <ellipse cx="22" cy="15.5" rx="15" ry="5.5" strokeOpacity=".045" />
          </g>
          <pattern id="bant" width="150" height="168" patternUnits="userSpaceOnUse">
            {/* Kaydırılmış iki sıra — üretim bandındaki şaşırtmalı diziliş */}
            <use href="#kutu" x="10" y="14" />
            <use href="#kutu" x="86" y="14" />
            <use href="#kutu" x="48" y="98" />
            <use href="#kutu" x="124" y="98" />
            <use href="#kutu" x="-28" y="98" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#bant)" />
      </svg>

      {/* İki ucu birleştiren yol: Manisa ↔ Hebei. İpek Yolu'nun bittiği ve
          başladığı yerler; tedarik zinciri de aynı hattı izliyor. */}
      <svg className="absolute inset-x-0 top-1/2 -translate-y-1/2 w-full" height="200" preserveAspectRatio="none" viewBox="0 0 1000 200">
        <path d="M60 140 C 300 40, 700 40, 940 140" fill="none" stroke="#F5B800" strokeOpacity=".28"
          strokeWidth="1.6" strokeDasharray="7 9" />
        <circle cx="60" cy="140" r="4.5" fill="#E8112D" fillOpacity=".45" />
        <circle cx="940" cy="140" r="4.5" fill="#E8112D" fillOpacity=".45" />
      </svg>
    </div>
  );
}

function Login({ error, busy, onSubmit }) {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <Zemin />
      <div className="relative w-full max-w-sm">

        {/* Marka bloğu — logo, iki şehir saati, ay-yıldız motifi */}
        <div className="relative overflow-hidden rounded-2xl bg-zinc-900 mb-4">
          {/* Arka plan: markanın sarısı + bayrakların kırmızısı, çok soluk */}
          <div aria-hidden className="absolute inset-0 opacity-[0.55]" style={{
            background:
              "radial-gradient(120% 90% at 12% 0%, rgba(245,184,0,.30) 0%, transparent 55%)," +
              "radial-gradient(100% 80% at 100% 100%, rgba(232,17,45,.26) 0%, transparent 60%)",
          }} />
          {/* Hilal + yıldız: iki bayrakta da var, tek motifle ikisine birden selam */}
          <svg aria-hidden viewBox="0 0 200 120" className="absolute -right-4 -top-3 w-44 opacity-[0.13]" fill="#F5B800">
            <path d="M108 60a34 34 0 1 1-24-32.5A27 27 0 1 0 84 92.5 34 34 0 0 1 108 60z" />
            <path d="m132 44 4.2 9.6 10.4.9-7.9 6.9 2.4 10.2-9.1-5.5-9.1 5.5 2.4-10.2-7.9-6.9 10.4-.9z" />
          </svg>

          <div className="relative px-5 pt-5">
            <div className="flex items-center gap-2">
              <svg width="30" height="30" viewBox="0 0 100 100" aria-label="Erican">
                <path d="M 86 26 A 42 42 0 1 0 86 74" fill="none" stroke="#F5B800" strokeWidth="15" />
                <rect x="12" y="43.5" width="46" height="13" fill="#F5B800" />
              </svg>
              <span className="text-white font-extrabold text-xl tracking-tight leading-none">
                R<span style={{ color: "#E8112D" }}>I</span>CAN
              </span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/45 mt-2">
              Yönetim Paneli · 管理面板 · Management Panel
            </div>
            <div className="mt-3 h-px bg-gradient-to-r from-[#F5B800]/70 via-white/10 to-transparent" />
          </div>

          <div className="relative"><Saatler /></div>
        </div>

        <div className="bg-white border border-zinc-200 rounded-xl p-5 space-y-3 kart-golge">
          <label className="block text-sm space-y-1.5">
            <span className="text-xs font-medium text-zinc-600">E-posta / Email</span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoComplete="email"
              className={inputCls} />
          </label>
          <label className="block text-sm space-y-1.5">
            <span className="text-xs font-medium text-zinc-600">Şifre / Password</span>
            <input value={pw} onChange={(e) => setPw(e.target.value)} type="password" autoComplete="current-password"
              className={inputCls}
              onKeyDown={(e) => e.key === "Enter" && onSubmit(email, pw)} />
          </label>
          {error && <div className="text-xs text-red-600 bg-red-50 border border-red-100 rounded-lg p-2">{error}</div>}
          <button onClick={() => onSubmit(email, pw)} disabled={busy}
            className="w-full py-2.5 rounded-lg bg-zinc-900 text-white text-sm font-medium hover:bg-zinc-800 active:bg-zinc-950 disabled:opacity-45 transition-colors">
            {busy ? "…" : "Giriş / Sign in"}
          </button>
        </div>

        <p className="text-center text-xs text-zinc-400 mt-4">🔒 Yetkisiz erişime kapalıdır · Authorized access only</p>
        <p className="text-center text-[10px] text-zinc-300 mt-1">Salihli OSB · Manisa</p>
      </div>
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [diag, setDiag] = useState(null);   // teşhis bilgisi
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => { setSession(data.session); setReady(true); });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session) { setProfile(null); setDiag(null); return; }
    supabase.from("profiles").select("*").eq("id", session.user.id).maybeSingle()
      .then(({ data, error }) => {
        if (data) { setProfile(data); return; }
        setDiag({
          userId: session.user.id,
          email: session.user.email,
          hata: error ? { code: error.code, message: error.message, details: error.details, hint: error.hint } : "HATA YOK — sorgu boş döndü (RLS satırı gizliyor ya da id eşleşmiyor)",
        });
      });
  }, [session]);

  const login = async (email, pw) => {
    setBusy(true); setError("");
    const { error } = await supabase.auth.signInWithPassword({ email, password: pw });
    if (error) setError(error.message === "Invalid login credentials" ? "E-posta veya şifre hatalı." : error.message);
    setBusy(false);
  };

  const logout = () => { supabase.auth.signOut(); setDiag(null); };

  if (!ready) return <div className="min-h-screen bg-zinc-100" />;
  if (!session) return <Login onSubmit={login} busy={busy} error={error} />;

  /* Teknik ayrıntı artık varsayılan olarak görünmüyor: kullanıcı id'si ve ham Postgres
     hatası son kullanıcıya ait bilgi değil. Destek gerekirse katlanmış bölümden açılır. */
  if (!profile) return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-xl p-5 text-sm space-y-3">
        <div className="font-semibold text-zinc-800">Hesabın henüz tanımlı değil</div>
        <p className="text-zinc-600 leading-relaxed">
          Girişin başarılı ama bu kullanıcıya bağlı bir kullanıcı profili bulunamadı.
          Yöneticiden hesabını tanımlamasını iste.
        </p>
        {diag ? (
          <details className="text-xs text-zinc-400">
            <summary className="cursor-pointer select-none">Teknik ayrıntı (destek için)</summary>
            <pre className="mt-2 bg-zinc-50 border border-zinc-100 rounded p-3 whitespace-pre-wrap break-all">
{JSON.stringify(diag, null, 2)}
            </pre>
          </details>
        ) : <div className="text-xs text-zinc-400">Kontrol ediliyor…</div>}
        <button onClick={logout} className="px-3 py-1.5 rounded border border-zinc-300 text-zinc-600">Çıkış</button>
      </div>
    </div>
  );

  return (
    <Suspense fallback={<div className="min-h-screen bg-[#F7F7F5] flex items-center justify-center text-sm text-zinc-400">Yükleniyor…</div>}>
      <EricanPanel profile={profile} onLogout={logout} />
    </Suspense>
  );
}
